const setPortfolios = ({ commit }, payload) => {
  commit('SET_PORTFOLIOS', payload)
}

export { setPortfolios }
